import { gql } from '@apollo/client';

export const assignmentFragment = gql`
  fragment Assignment on Assignment {
    id: _id
    name

    minScoreToShowExplanation
    allowAnswersAfterTimeLimit
    allowPracticeOnlyAfterExpired
    showSolutionsOnlyAfterExpired
    showOnlyTotalScore
    timeLimit

    resumable
    sent
    studentsCount

    scores {
      positive
      negative
      neutral
    }

    stats

    enabled
    exercises
    expirationDate
  }
`;

export const assignmentAnswerFragment = gql`
  fragment AssignmentAnswer on AssignmentAnswer {
    id: _id
    finishedAt
    maxScore
    score
    student
  }
`;

export const assignmentResultFragment = gql`
  fragment AssignmentResult on AssignmentResult {
    assignment
    assignmentName
    exercises
    maxQuestionScore
    maxScore
    score
    students
  }
`;
